import { useSuspenseQuery } from "@tanstack/react-query";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useAuthStore } from "src/auth";
import { SubscribeCheckout } from "src/components/SubscribeCheckout";
import { InviteCodeForm } from "src/components/UpgradePaywallInviteCodeForm";
import { billingProductsQueryOptions } from "src/queries/billing";

import { NavbarUpgradePaywall } from "../layout/NavbarUpgradePaywall";

export const UpgradePaywall = observer(function UpgradePaywall() {
  const { t } = useTranslation();
  const authStore = useAuthStore();
  const productsQuery = useSuspenseQuery(billingProductsQueryOptions());
  const [showInviteCode, setShowInviteCode] = useState(false);

  const eligibleForTrial = !authStore.hasUsedTrial;
  const products = productsQuery.data.products;

  return (
    <div className="h-full relative z-10 flex flex-col pt-sztama-auth-toolbar-height">
      <NavbarUpgradePaywall />
      <main className="grow pb-16">
        <div className="mb-8">
          <h2 className="mt-4 text-center text-lg font-bold sm:text-5xl">
            {t("planChooser.title")}
          </h2>
          <p className="mx-auto mt-4 max-w-3xl text-center text-md text-gray-500">
            {eligibleForTrial
              ? t("planChooser.subtitle")
              : t("planChooser.trialEndedSubtitle")}
          </p>
        </div>
        <div className="mx-auto w-full max-w-6xl px-4">
          {showInviteCode ? (
            <div className="mx-auto max-w-md">
              <InviteCodeForm
                onCancelClick={() => {
                  setShowInviteCode(false);
                }}
              />
            </div>
          ) : (
            <div className="space-y-6">
              <SubscribeCheckout
                products={products}
                eligibleForTrial={eligibleForTrial}
                variant="full"
              />
              <div className="text-center">
                <button
                  type="button"
                  className="cursor-pointer text-sm text-gray-500 underline underline-offset-4 hover:text-gray-900"
                  onClick={() => {
                    setShowInviteCode(true);
                  }}
                >
                  {t("planChooser.inviteCode")}
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
});
